/**
 * Mã nguồn dữ liệu — suy từ tên hiển thị và **không sửa được sau khi tạo** (chép từ native).
 *
 * Mã đi vào `?source=` của app di động và cấu hình của hệ thống ngoài, phải khớp CHECK
 * `^[a-z0-9][a-z0-9-]{0,39}$` của `bao_cao_source.code`. Suy từ tên thì người dùng chỉ phải trả lời câu
 * họ biết: "nguồn này tên gì?".
 */

/** Cùng trần với CHECK của `bao_cao_source.code`. */
export const DAI_TOI_DA = 40;

const THAY = /[^a-z0-9]+/g;

/** Tên tiếng Việt → mã máy chủ nhận được. Rỗng nếu tên không sinh ra được mã. */
export function slugMaNguon(ten: string): string {
  const s = (ten || '')
    .normalize('NFD')
    // Khối dấu thanh kết hợp U+0300–U+036F, viết bằng mã thoát để trình biên tập không hiện sai.
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .toLowerCase()
    .replace(THAY, '-')
    .replace(/^-+|-+$/g, '');

  // Server cho phép số đứng đầu, nên "2026 báo cáo" ra thẳng `2026-bao-cao`.
  return s.slice(0, DAI_TOI_DA).replace(/-+$/g, '');
}

/** Mã chưa có trong `daCo`, suy từ tên; thêm hậu tố `-2`, `-3`… khi trùng. Rỗng nếu không sinh được. */
export function maNguonDuyNhat(ten: string, daCo: readonly string[]): string {
  const goc = slugMaNguon(ten);
  if (!goc) return '';

  const dung = new Set(daCo);
  if (!dung.has(goc)) return goc;

  for (let i = 2; i < 100; i += 1) {
    const hau = `-${i}`;
    // Cắt phần gốc để chừa chỗ cho hậu tố; ghép rồi mới cắt sẽ xoá mất hậu tố khi tên đã đủ 40 ký tự.
    const than = goc.slice(0, DAI_TOI_DA - hau.length).replace(/-+$/g, '');
    const thu = `${than}${hau}`;
    if (!dung.has(thu)) return thu;
  }
  return '';
}
